var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutesIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/big arrow/right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.53906 9.50366L2.53906 6.04351M12.4346 8.20461L8.2092 11.9605C8.02325 12.1258 7.72929 11.9938 7.72929 11.745V10.657C7.72929 10.0201 7.2129 9.50366 6.57591 9.50366H4.84583C4.52733 9.50366 4.26914 9.24547 4.26914 8.92697L4.26914 6.6202C4.26914 6.30171 4.52733 6.04351 4.84583 6.04351H6.57591C7.2129 6.04351 7.72929 5.52713 7.72929 4.89013V3.80215C7.72929 3.55336 8.02325 3.42135 8.2092 3.58664L12.4346 7.34256C12.6927 7.57197 12.6927 7.97521 12.4346 8.20461Z",
    stroke: "#B8B8C1",
    strokeWidth: 1.15338,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIconLight);
export default __webpack_public_path__ + "static/media/routes_icon_light.2dcac532007b76b8d67430d7e3d6ea12.svg";
export { ForwardRef as ReactComponent };